import { RemoveWorkspacePoints } from '../points.actions';
import { TPointsByWorkspace } from '../points.model';

export function removeWorkspacePoints(
  oldState: TPointsByWorkspace,
  action: RemoveWorkspacePoints,
): TPointsByWorkspace {
  const { [action.payload.workspaceId]: _removed, ...state } = oldState;

  return state;
}
